// Das Fenster „Neue Bestellung" hängt an der Adresse (`?neu=1`).
//
// Befund 03.11.2026: „Manchmal nach dem Klicken auf ‚Zurück' kommt das
// Modal von ‚Neue Bestellung'." Öffnen legte einen Verlaufsschritt an —
// gewollt, damit die Zurück-Geste des Telefons das Fenster schließt.
// Schließen und Speichern legten aber JEWEILS EINEN WEITEREN an, statt den
// des Fensters zu verbrauchen. „Zurück" lief danach in diesen Schritt
// hinein und öffnete das Fenster wieder.
//
// Die Regel jetzt: Wer das Fenster per Klick geöffnet hat, verbraucht beim
// Schließen genau diesen Schritt (history.back). Kam es über die Adresse
// (Link, Neuladen), gibt es keinen eigenen Schritt — dann wird `?neu`
// ersetzt, nicht angehängt. Nach dem Speichern ERSETZT die neue Bestellung
// den Schritt des Fensters.

type Navigate = (opts: never) => unknown;
type Router = { history: { back: () => void } };

let perKlickGeoeffnet = false;

export function neueBestellungOeffnen(navigate: Navigate): void {
  perKlickGeoeffnet = true;
  void navigate({
    search: ((prev: { neu?: 1 }) => ({ ...prev, neu: 1 as const })) as never
  } as never);
}

export function neueBestellungSchliessen(router: Router, navigate: Navigate): void {
  if (perKlickGeoeffnet) {
    perKlickGeoeffnet = false;
    router.history.back();
    return;
  }
  void navigate({
    replace: true,
    search: ((prev: { neu?: 1 }) => ({ ...prev, neu: undefined })) as never
  } as never);
}

/** Nach dem Speichern: die neue Bestellung tritt an die Stelle des Fensters. */
export function neueBestellungGespeichert(navigate: Navigate, bestellnr: string): void {
  perKlickGeoeffnet = false;
  void navigate({ to: '/bestellungen/$bestellnr', params: { bestellnr }, replace: true } as never);
}

/** Ist das Fenster anders zugegangen (Zurück-Geste), gilt der Schritt als verbraucht. */
export function neueBestellungVergessen(): void {
  perKlickGeoeffnet = false;
}
